import React from "react";
import { NavLink } from "react-router-dom";
import imglogo from "../img/medical.png";
function Navbar() {
  return (
    <>
      {/* <nav class="navbar bg-dark border-bottom border-body" data-bs-theme="dark">
  <!-- Navbar content -->
</nav> */}
      <nav
        className="navbar navbar-expand-lg bg-body-tertiary"
        data-bs-theme="dark"
      >
        <div className="container-fluid">
          <img
            src={imglogo}
            alt="Bootstrap"
            width="50"
            height="40"
            style={{ marginLeft: "10px", marginRight: "20px" }}
          />

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul
              className="navbar-nav me-auto mb-2 mb-lg-0"
              style={{ color: "whitesmoke" }}
            >
              <li className="nav-item">
                <NavLink className="nav-link active" aria-current="page" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/About">
                  About
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <NavLink
                  className="nav-link dropdown-toggle"
                  to="/dropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  AdminHandle
                </NavLink>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink className="dropdown-item" to="/Doner">
                      Doner
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link "
                  to="/DonerList"
                  tabIndex="-1"
                  aria-disabled="true"
                >
                  DonerList
                </NavLink>
              </li>
            </ul>
            <form className="d-flex" role="search">
              
              <button className="btn btn-outline-success" type="submit">
                LogOut
              </button>
            </form>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
